import * as React from "react"
import { Outlet, useNavigate } from "react-router-dom"

import PageContainer from "@podcastsoundboard/ps-lib/components/PageContainer/PageContainer"

//
import AppBarItems from "../../components/AppBar/AppBarItems"
import AppBar from "../../components/AppBarWithDrawer/AppBar"
import Drawer from "../../components/AppBarWithDrawer/Drawer"
import DarkModeToggle from "../../components/DarkModeToggle"
import { useAppSelector } from "../../redux"
import { AdminListItems } from "./AdminListItems"
import {
  Box,
  Divider,
  IconButton,
  List,
  Toolbar,
} from "@podcastsoundboard/ps-lib/ui"
import ChevronLeftIcon from "@podcastsoundboard/ps-lib/ui/icons/ChevronLeft"
import ChevronRightIcon from "@podcastsoundboard/ps-lib/ui/icons/ChevronRight"

export default function AdminDashboard() {
  const navigate = useNavigate()

  const [open, setOpen] = React.useState(false)
  const toggleDrawer = () => {
    setOpen(!open)
  }

  const darkModeEnabled = useAppSelector((state) => state.darkModeEnabled)
  const currentUserProfile = useAppSelector((state) => state.currentUserProfile)

  React.useEffect(() => {
    if (!currentUserProfile || !currentUserProfile.isAdmin) navigate("/app")
  })

  return (
    <>
      <Box className="flex h-screen">
        <AppBar position="absolute" open={open}>
          <Toolbar className="pr-[24px]">
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={toggleDrawer}
              className={open ? "hidden" : "mr-9"}
            >
              <ChevronRightIcon />
            </IconButton>

            <Box className="grow" />

            <DarkModeToggle />
            {/* <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              className="grow"
            >
              Administration
            </Typography> */}

            <AppBarItems />
          </Toolbar>
        </AppBar>

        <Drawer variant="permanent" open={open}>
          <Toolbar className="flex items-center justify-start px-2">
            <IconButton onClick={toggleDrawer}>
              <ChevronLeftIcon />
            </IconButton>
          </Toolbar>

          <Divider />

          <List>
            <AdminListItems />
          </List>
          {/* <Divider />
          <List>{secondaryListItems}</List> */}
        </Drawer>

        <Box
          component="main"
          className="grow h-screen overflow-auto mobile-have-min-width"
        >
          <Toolbar />

          <PageContainer darkModeEnabled={darkModeEnabled}>
            <Outlet />
          </PageContainer>
        </Box>
      </Box>
    </>
  )
}
